import posthog from "posthog-js";

type EventProperties = Record<string, string | number | boolean | null | undefined>;

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com";

const shouldTrack =
  import.meta.env.VITE_POSTHOG_DISABLED !== "true" && Boolean(POSTHOG_KEY && POSTHOG_KEY.trim() !== "");

let initialized = false;

export function initPostHog(): void {
  if (!shouldTrack || initialized) {
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    ui_host: "https://us.posthog.com",
    capture_pageview: true,
    capture_pageleave: true,
    persistence: "localStorage",
    autocapture: true,
    // Session replay parity for the vendor migration.
    disable_session_recording: false,
  });

  initialized = true;
}

export function identifyPostHog(distinctId: string, properties?: EventProperties): void {
  if (!shouldTrack || !initialized) {
    return;
  }

  posthog.identify(distinctId, properties);
}
